import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import { hostRoutes, publicRoutes, studentRoutes } from "routes";
import { useContextHospi } from "context/ContextHospi";
import {
  HOST_CHATS_ROUTE,
  HOST_MATCHES_ROUTE,
  HOST_PROFILE_ROUTE,
  HOST_PROFILEVIEW_ROUTE,
  HOST_ROOMS_ROUTE,
  HOST_TENANTS_ROUTE,
  LANGUAGES,
  LOGIN_ROUTE,
  STUDENT_CHATS_ROUTE,
  STUDENT_MATCHES_ROUTE,
  STUDENT_PROFILE_ROUTE,
  STUDENT_PROFILEVIEW_ROUTE,
  STUDENT_ROOMS_ROUTE,
} from "utils/constants";
import { ContainerMenu, ConteinerPopup, Item, ItemUser } from "./styles";
import { PopupMenu } from "components/PopupMenu";
import SelectLanguage from "components/SelectLanguage";

export const studentMenuRoutes = [
  STUDENT_PROFILEVIEW_ROUTE,
  STUDENT_ROOMS_ROUTE,
  STUDENT_MATCHES_ROUTE,
  STUDENT_CHATS_ROUTE,
];

export const hostMenuRoutes = [
  HOST_PROFILEVIEW_ROUTE,
  HOST_ROOMS_ROUTE,
  HOST_MATCHES_ROUTE,
  HOST_CHATS_ROUTE,
  HOST_TENANTS_ROUTE,
];

export const Menu: React.FC = () => {
  const navigate = useNavigate();
  const { userStatus, setUser, getNameUser, changeUser, userProfile } =
    useContextHospi();

  const { t, i18n } = useTranslation('header');

  return (
    <ContainerMenu>
      {publicRoutes.map((item) => (
        <Item key={item.path}>
          <NavLink to={`/${i18n.language}${item.path.slice(5)}`}>{t(`menu.${item.keyLocalize}`)}</NavLink>
        </Item>
      ))}
      {userStatus === undefined ? (
        <Item>
          <NavLink to={userStatus === undefined ? `/${i18n.language}${LOGIN_ROUTE.slice(5)}` : `/${i18n.language}/`}>
            {t("menu.signInUp")}
          </NavLink>
        </Item>
      ) : (
        <Item>
          <PopupMenu title={`${t("menu.login")} `} top="28px">
            <ConteinerPopup>
              <ItemUser>
                <p>{t(`subMenu.signedIn`)}</p>
                <p>{getNameUser}</p>
              </ItemUser>
              <hr />
              {userStatus === "student" &&
                userProfile &&
                studentRoutes
                  .filter((item) => studentMenuRoutes.includes(item.path))
                  .map((item) => (
                    <Item key={item.path} popup>
                      <NavLink to={`/${i18n.language}${item.path.slice(5)}`}>
                        {t(`subMenu.${item.keyLocalize}`)}
                      </NavLink>
                    </Item>
                  ))}
              {userStatus === "host" &&
                userProfile &&
                hostRoutes
                  .filter((item) => hostMenuRoutes.includes(item.path))
                  .map((item) => (
                    <Item key={item.path} popup>
                      <NavLink to={`/${i18n.language}${item.path.slice(5)}`}>
                        {t(`subMenu.${item.keyLocalize}`)}
                      </NavLink>
                    </Item>
                  ))}
              {["student", "host"].includes(userStatus) && !userProfile && (
                <Item popup>
                  <NavLink
                    to={`${userStatus === "host"
                        ? `/${i18n.language}${HOST_PROFILE_ROUTE.slice(5)}`
                        : `/${i18n.language}${STUDENT_PROFILE_ROUTE.slice(5)}`
                      }`}
                  >
                    {t(`subMenu.profile`)}
                  </NavLink>
                </Item>
              )}
              <hr />
              <Item
                className="logout"
                popup
                onClick={() => {
                  Auth.signOut({ global: true }).finally(() => {
                    setUser(undefined);
                    changeUser(undefined);
                    navigate(`/${i18n.language}/`);
                  });
                }}
              >
                {t(`subMenu.signOut`)}
              </Item>
            </ConteinerPopup>
          </PopupMenu>
        </Item>
      )}
      <Item>
        <SelectLanguage
          items={LANGUAGES}
          showCountryName={false}
          initial={userProfile?.default_language || LANGUAGES[0]}
        />
      </Item>
    </ContainerMenu>
  );
};
